import { createContext, useContext } from 'react';
import { TEAM_INITIAL_STATE } from './Team.constants';
import { tTeamContext } from './Team.types';

export const TeamContext = createContext(TEAM_INITIAL_STATE);

export function useTeamContext(): tTeamContext {
  return useContext(TeamContext);
}
